import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

const useIsMobileDevice = (supportDesktopClient = false) => {
  const { greaterThan } = useScreenSize();

  if (supportDesktopClient) {
    return !greaterThan(Size.Small);
  }

  return !greaterThan(Size.XSmall);
};

export default useIsMobileDevice;
